export const MetaTypeToTypeId = {
  HUBSPOT: 0,
  INTEGRATION: 1,
  PORTAL_SPECIFIC: 2,
  CMS_HUBDB: 3,
  HUBSPOT_EVENT: 4,
  INTEGRATION_EVENT: 5,
  PORTAL_SPECIFIC_EVENT: 6
};